import { Grid } from "@mui/material";
import { DataGridPro, GridColDef, GridRowParams } from "@mui/x-data-grid-pro";
import { EditableTable } from "components/alove/EditableTable";
import { create } from "domain";
import { ActionSetting } from "layouts/screens/screenView/components/action";
import { Question } from "models/batch/Question";
import { QuestionResponse, QuestionResponseType } from "models/batch/QuestionResponse";
import { camelCaseToCapitalizedWords } from "utils/globalsUtils";
import {
  createQuestionResponse,
  deleteQuestionResponse,
  updateQuestionResponse,
  updateQuestionResponseOrder,
} from "utils/questionsUtils";

const MDInput = require("components/MDInput/index.js").default;

export const Answers = ({
  question,
  setQuestion,
}: {
  question: Question;
  setQuestion: Function;
}) => {
  const getDetailPanelContent =  (params: GridRowParams<QuestionResponse>) => (
    <Grid container mt={1}>
      <Grid size={1} />
      <Grid size={9}>
        <ActionSetting
          action={params.row.action}
          setAction={(action) => {
            const newRow = { ...params.row, action };
            updateQuestionResponse(newRow.id, newRow);
            setQuestion({
              ...question,
              responses: question.responses.map((r) => (r.id === newRow.id ? newRow : r)),
            });
          }}
        />
      </Grid>
    </Grid>
  );

  const columns: GridColDef<QuestionResponse>[] = [
    {
      field: "txt",
      headerName: "Answer",
      flex: 3,
      editable: true,
    },
    {
      field: "groupTxtId",
      headerName: "Group",
      flex: 1,
      editable: true,
    },
    {
      field: "type",
      headerName: "Type",
      flex: 1,
      editable: true,
      type: "singleSelect",
      valueOptions: Object.entries(QuestionResponseType)
        .filter(([key, value]) => typeof value === "number")
        .map(([key, value]) => ({ value, label: camelCaseToCapitalizedWords(key) })),
    },
  ];
  const processRowUpdate = (newRow: QuestionResponse, oldRow: QuestionResponse) => {
    if (newRow.txt) {
      updateQuestionResponse(newRow.id, newRow);
    } else {
      newRow.txt = oldRow.txt;
    }
    return newRow;
  };
  const onAddRow = async (newRow: QuestionResponse) => {
    newRow.questionId = question.id;
    await createQuestionResponse(newRow);
  };
  const onReorder = (ids: any[]) => {
    updateQuestionResponseOrder(ids, question.id);
  };
  const onDelRow = (row: QuestionResponse) => {
    deleteQuestionResponse(row.id)
  };
  return (
    <EditableTable
      processRowUpdate={processRowUpdate}
      columns={columns}
      rows={question.responses}
      modelName="Answer"
      onAddRow={onAddRow}
      onRowOrderChange={onReorder}
      getDetailPanelContent={getDetailPanelContent}
      getDetailPanelHeight={() => 70}
      onDelRow={onDelRow}
    />
  );
};
